import TextButton from '@oberoninternal/travelbase-ds/components/action/TextButton';
import Body from '@oberoninternal/travelbase-ds/components/primitive/Body';
import React, { FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { StringParam } from 'use-query-params';
import Tooltip from './designsystem/Tooltip';
import useQueryParams from '../hooks/useQueryParams';

interface Props {
    tripsInViewCount: number;
    allTripsCount: number;
    specialFilterActive?: boolean;
}

const PlannerInfoText: FC<React.PropsWithChildren<Props>> = ({
    tripsInViewCount,
    allTripsCount,
    specialFilterActive,
}) => {
    const [, setParams] = useQueryParams({ specialId: StringParam });
    if (tripsInViewCount === 0 && specialFilterActive) {
        const message = (
            <Body variant="small">
                <FormattedMessage
                    defaultMessage="Niet beschikbaar in deze periode. Klik <button>hier</button> om ander aanbod te tonen"
                    values={{
                        button: (chunks: ReactNode) => (
                            <TextButton
                                onClick={() => setParams({ specialId: undefined }, 'replaceIn')}
                                style={{ fontSize: 'inherit' }}
                            >
                                {chunks}
                            </TextButton>
                        ),
                    }}
                />
            </Body>
        );
        return (
            <>
                <Tooltip containerProps={{ className: 'gt-s' }} placement="right">
                    {message}
                </Tooltip>
                <Tooltip containerProps={{ className: 'lt-s' }} placement="auto-end">
                    {message}
                </Tooltip>
            </>
        );
    }
    if (allTripsCount > 0 && tripsInViewCount === 0) {
        return (
            <Body
                variant="small"
                style={{
                    marginTop: 'auto',
                    marginBottom: 'auto',
                    paddingRight: '1rem',
                }}
            >
                <FormattedMessage defaultMessage="Beschikbaarheid onbekend in deze periode." />
            </Body>
        );
    }

    return null;
};

export default PlannerInfoText;
